import React, { FC } from 'react';

type HotspotButtonProps = {
    className:string,
    onClick: ()=>void,
    slot: string,
    'data-position':string,
    'data-normal':string,
}
export const HotspotButton: FC<HotspotButtonProps> = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <button type="button" {...props}>
    <img src="https://wwf.pages.dmdr.io/ar-animals/AR-Module/hotspot-item.png" alt="" />
  </button>
);
